document.addEventListener('DOMContentLoaded', function() {
    const contactButtonContainer = document.getElementById('contactButtonContainer');
    const threshold = 5; // スクロールが完全に下部に到達したとみなすための閾値（ピクセル）

    function toggleContactButtonVisibility() {
        // ドキュメント全体の高さ
        const documentHeight = document.documentElement.scrollHeight;
        // ブラウザの表示領域の高さ
        const viewportHeight = window.innerHeight;
        // 現在のスクロール位置
        const scrollPosition = window.scrollY;

        // スクロールが下部に非常に近い、または下部に到達しているかを判断
        // (documentHeight - viewportHeight) はスクロール可能な最大位置
        const isAtBottom = (scrollPosition + viewportHeight >= documentHeight - threshold);

        // スマホサイズの場合のみボタンの表示/非表示を制御
        // (window.innerWidth < 768 はCSSの@media (min-width: 768px) と連携)
        if (window.innerWidth < 768) {
            if (isAtBottom) {
                contactButtonContainer.classList.add('hidden');
            } else {
                contactButtonContainer.classList.remove('hidden');
            }
        } else {
            // PCサイズでは常に非表示にする（CSSでdisplay: none; が適用されているが、念のため）
            contactButtonContainer.classList.add('hidden');
        }
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', toggleContactButtonVisibility);

    // リサイズイベントリスナーを追加（画面サイズ変更時に再評価）
    window.addEventListener('resize', toggleContactButtonVisibility);

    // ページロード時にも一度実行して初期状態を設定
    toggleContactButtonVisibility();
});